import { ChatStore } from "@/stores/ChatStore";
import { EExternalLinkType, TExternalLink } from "@/types/TExternalLink";
import { EBrandName, TInfoBox } from "@/types/TInfoBox";

export default function mapExtractedExternalLinks(externalLinks: TExternalLink[]): TInfoBox[] {
  // Initialize grouped external links structure for all brands with a deep copy
  const grouppedExternalLinks: TInfoBox[] = ChatStore.getState().displayedExternalLinks.map(group => ({
    ...group,
    items: [...group.items]
  }));
  const addLinkToGroup = (link: TExternalLink, brandName: EBrandName) => {
    const group = grouppedExternalLinks.find(g => g.brand === brandName);
    
    // Only add the link if it doesn't already exist in the group
    if (group && !group.items.some(item => item.value === link.value && item.type === link.type)) {
      group.items.push(link);
    }
  };

  // Group links by brand based on email domains and URL domains
  externalLinks.forEach((link) => {
    let matchingBrand: EBrandName | undefined;

    if (link.type === EExternalLinkType.email) {
      // Extract brand from email domain (e.g., schaden@domcura.de -> domcura)
      const emailDomain = link.value.split('@')[1];
      matchingBrand = Object.values(EBrandName).find(brand => 
        emailDomain?.includes(brand)
      );
    } else if (link.type === EExternalLinkType.url) {
      // Extract brand from URL domain (e.g., https://domcura.de -> domcura)
      matchingBrand = Object.values(EBrandName).find(brand => 
        link.value.includes(brand) || link.originalText?.includes(brand)
      );
    }

    addLinkToGroup(link, matchingBrand || EBrandName.default);
  });

  // Add phone numbers to brands that have other contact information
  const phoneLinks = externalLinks.filter(link => link.type === EExternalLinkType.phone);
  phoneLinks.forEach((phoneLink) => {
    grouppedExternalLinks.forEach((group) => {
      // Add phone number to brands that have email or URL links
      if (group.items.length > 0 && !group.items.some(item => item.type === EExternalLinkType.phone)) {
        group.items.push(phoneLink);
      }
    });
  });

  // Sort items within each group: phone first, email second, url third
  grouppedExternalLinks.forEach((group) => {
    group.items.sort((a, b) => {
      const typeOrder = {
        [EExternalLinkType.phone]: 1,
        [EExternalLinkType.email]: 2,
        [EExternalLinkType.url]: 3
      };
      return typeOrder[a.type] - typeOrder[b.type];
    });
  });

  return grouppedExternalLinks;
}